import { createStyles, makeStyles } from '@hawkins/styles';
export function textStyles(theme) {
    var hawkins = theme.hawkins, hawkinsVariables = theme.hawkinsVariables;
    return createStyles({
        /** Class name of the root element in the body variant.  */
        body: {
            fontFamily: hawkinsVariables.fontFamily.fontFamilySans,
            fontWeight: hawkins.body.fontWeightRegular,
            lineHeight: hawkins.body.lineHeightRegular,
        },
        /** Class name of the root element in the body or monospaced variant at level 0.  */
        body0: {
            fontSize: hawkins.body.fontSize0,
        },
        /** Class name of the root element in the body or monospaced variant at level 1.  */
        body1: {
            fontSize: hawkins.body.fontSize1,
        },
        /** Class name of the root element in the body or monospaced variant at level 2.  */
        body2: {
            fontSize: hawkins.body.fontSize2,
        },
        /** Class name of the root element in the body or monospaced variant when the component is bolded.  */
        bodyBold: {
            fontWeight: hawkins.body.fontWeightBold,
        },
        /** Class name of the root element at level -1. */
        compact: {
            fontSize: hawkinsVariables.fontSizes.fontSize0,
        },
        /** Class name of the root element in the label variant. */
        label: {
            fontFamily: hawkinsVariables.fontFamily.fontFamilySans,
            fontWeight: hawkins.label.fontWeightRegular,
            lineHeight: hawkins.label.lineHeightRegular,
        },
        /** Class name of the root element in the label variant at level 0.  */
        label0: {
            fontSize: hawkins.label.fontSize0,
        },
        /** Class name of the root element in the label variant at level 1.  */
        label1: {
            fontSize: hawkins.label.fontSize1,
        },
        /** Class name of the root element in the label variant when the component is bolded.  */
        labelBold: {
            fontWeight: hawkins.label.fontWeightBold,
        },
        /** Class name of the root element in the monospaced variant. */
        monospaced: {
            fontFamily: hawkinsVariables.fontFamily.fontFamilyMono,
            fontWeight: hawkins.body.fontWeightRegular,
            lineHeight: hawkins.body.lineHeightRegular,
        },
        /** Class name of the root element. */
        root: {
            color: hawkins.textColor.textColorRegular,
            marginBottom: 0,
            marginTop: 0,
            // TODO(style): Add an `inheritSize` prop so we can use a prop instead of this CSS override
            // and also allow the user to set `font-size: inherit` without being inside a `TextLink`?
            '& .Hawkins-TextLink': { fontSize: 'inherit' },
        },
        /** Class name of the root element in the disabled color variant. */
        rootColorDisabled: {
            color: hawkins.textColor.textColorXlight,
        },
        /** Class name of the root element in the faded color variant. */
        rootColorFaded: {
            color: hawkins.textColor.textColorLight,
        },
        /** Class name of the root element in the reverse color variant. */
        rootColorReverse: {
            color: hawkins.textColor.textColorReverseRegular,
        },
    });
}
export var useTextStyles = makeStyles(textStyles, { name: 'Hawkins-Text' });
